import * as React from 'react';
import ReactDom from 'react-dom';
import { DimmerPrimitive } from './dimmer.primitive';
export const Dimmer = ({ className, onClick, title, ...props }) => {
    return ReactDom.createPortal(React.createElement(DimmerPrimitive, { className: className, onClick: onClick, title: title, ...props }), document.body);
};
Dimmer.displayName = 'Dimmer';
//# sourceMappingURL=dimmer.js.map